import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-z-small', 'IconLetterZSmall', [
  ['path', { d: 'M10 8h4l-4 8h4', key: 'svg-0' }],
]);
